import { ActivityComponentType } from '@stackflow/react'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import { s_process } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import ReviewLessonStyleBody from '../../new-portal/review/ReviewLessonStyleBody'
import WebviewStackContainer from '../common/WebviewStackContainer'

const ReviewLessonStyleActivity: ActivityComponentType = () => {
  const { back } = useAppRouter()
  const { t } = useTranslation()
  return (
    <div>
      <WebviewStackContainer height="52px" onBack={back} title={t(s_process.require_correction)}>
        <ReviewLessonStyleBody />
      </WebviewStackContainer>
    </div>
  )
}

export default ReviewLessonStyleActivity
